import { render } from "./CreateCompanyCategoryView.vue?vue&type=template&id=293167c8"
import script from "./CreateCompanyCategoryView.vue?vue&type=script&lang=js"
export * from "./CreateCompanyCategoryView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kokleng/Documents/Dollar/core_system/from_gitlab/pos-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__